module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/c3VCGv/tc-custom/9781455608102.jpg?1721404315792",
      "alt": "This image is the cover for the book Majestic Middle Tennessee, Majesty"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Majestic Middle Tennessee, Majesty\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"The happy events, the human asides, historic happenings, and family legends . . . make its pages delightful to read. Smith writes warmly and with an easy appreciative wit.\" -The Tennesseean")]), _c('p', [_vm._v("Central Tennessee is a fascinating and historic area. Home to Andrew Jackson and James K. Polk, it was a major battleground during the Civil War. Majestic Middle Tennessee looks at ninety-five glorious antebellum homes in the central Tennessee region. Featured here are the sumptuous Rattle and Snap, the crown prince of them all; Mulberry Hill, where a Yankee stranger was mysteriously shot to death; and Foxview, home to children and cousins by the dozens. Hundreds of photographs and fascinating text detail the exciting and tragic history of each home.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Reid Smith\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Paddle Wheel Publications\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0